<div class="receipt">
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        .receipt {
            font-family: Arial, sans-serif;
            color: #000000;
            max-width: 800px;
            margin: auto;
            padding: 20px;
            border: 1px solid #ccc;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        .header {
            text-align: center;
            margin-bottom: 20px;
        }

        .header .company-name h1 {
            font-size: 28px;
            font-weight: bold;
        }

        .order-section {
            border-bottom: 1px solid #000000;
            padding-bottom: 10px;
            margin-bottom: 20px;
        }

        .info {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
        }

        .info div {
            width: 32%;
        }

        .info h3 {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 5px;
        }

        .info p {
            font-size: 16px;
            margin: 5px 0;
            line-height: 1.4;
        }

        .info p strong {
            font-size: 16px;
            font-weight: bold;
        }

        .items table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
        }

        .items th,
        .items td {
            border: 1px solid #ccc;
            padding: 8px;
            text-align: left;
            font-size: 16px;
        }

        .items th {
            font-weight: bold;
            background-color: #f9f9f9;
        }
    </style>

    <!-- Header -->
    <div class="header">
        <div class="company-name">
            <h1>PRID LIB</h1>
        </div>
    </div>

    <!-- Order List -->
    <div *ngFor="let d of printData" class="order-section">
        <div class="info">
            <!-- Sender Information -->
            <div class="sender">
                <h3>Sender:</h3>
                <p><strong>Name:</strong> {{d.senderName}}</p>
                <p><strong>Mobile:</strong>
                    {{showOrderDetails ? d.senderPhone : d.senderPhone.slice(-4).padStart(d.senderPhone.length, '*')}}
                </p>
                <p><strong>Delivery message:</strong>
                    <br>{{d.deliveryMessage}}
                </p>
            </div>

            <!-- Order Details -->
            <div class="order-details">
                <h3>Order Details:</h3>
                <p><strong>Order Number:</strong> {{d.orderNumber}}</p>
                <p><strong>Created:</strong> {{d.orderDate | date:'short'}}</p>
                <p><strong>Status:</strong> {{d.orderStatus}}</p>
            </div>

            <!-- Receiver Information -->
            <div class="receiver">
                <h3>Receiver:</h3>
                <p><strong>Name:</strong> {{d.recieverName}}</p>
                <p><strong>Mobile:</strong> {{d.recieverPhone}}</p>
            </div>
        </div>

        <!-- Item List -->
        <div class="items">
            <table>
                <thead>
                    <tr>
                        <th>Product Name</th>
                        <th>Qty</th>
                        <th *ngIf="showOrderDetails">Total</th>
                    </tr>
                </thead>
                <tbody *ngFor="let items of d.orderItems">
                    <tr>
                        <td>{{items.productDisplayText}}</td>
                        <td>{{items.quantity}}</td>
                        <td *ngIf="showOrderDetails">{{items.totalRetailPrice}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
